import { render, staticRenderFns } from "./editPreInfo.vue?vue&type=template&id=21be3cad&"
import script from "./editPreInfo.vue?vue&type=script&lang=js&"
export * from "./editPreInfo.vue?vue&type=script&lang=js&"
import style0 from "./editPreInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports